import React, { useState, useEffect } from "react";
import { endPoints } from "../../../constant/Environment";
import { addData, deleteData, getAllData } from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import PageHeader from "../../../components/PageHeader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import DeleteIcon from "@mui/icons-material/Delete";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => { onPageChange(event, 0); };
  const handleBackButtonClick = (event) => { onPageChange(event, page - 1); };
  const handleNextButtonClick = (event) => { onPageChange(event, page + 1); };
  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const BlockDomain = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [domainName, setDomainName] = useState("");
  const [reason, setReason] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filterValue, setFilterValue] = useState("");

  const handleClose = () => {
    setShow(false);
    setDomainName("");
    setReason("");
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => { setPage(newPage); };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const blockDomainData = [
    { domainname: "example.com" },
    { domainname: "test.com" },
    { domainname: "blocked.com" },
  ];

  const fetchList = async () => {
    try {
      setIsLoading(true);
      const response = await getAllData(endPoints.api.GET_BLOCK_DOMAIN);
      setIsLoading(false);
      if (response?.status === "success") {
        setRows(response.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleAdd = async () => {
    if (!domainName.trim()) {
      ErrorToast("Domain name / email is required");
      return;
    }
    try {
      setIsLoading(true);
      const response = await addData(endPoints.api.ADD_BLOCK_DOMAIN, { 
        domainName: domainName, 
        id: 0,
        reason: reason,
      });
      setIsLoading(false);
      if (response?.data?.status === "success") {
        SuccesToast(response?.data?.message || "Domain blocked successfully");
        fetchList();
        handleClose();
      } else {
        ErrorToast(response?.data?.message || "Failed to block domain");
      }
    } catch (error) {
      setIsLoading(false);
      ErrorToast("Something went wrong");
      console.error(error);
    }
  };

  const deleteDomain = async (row) => {
    try {
      setIsLoading(true);
      const url = `${endPoints.api.DELETE_BLOCK_DOMAIN}?domainName=${encodeURIComponent(row?.domainName)}`;
      await deleteData(url);
      setIsLoading(false);
      fetchList();
      SuccesToast("Deleted Successfully");
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleFilterChange = (event) => {
    setFilterValue(event.target.value.toLowerCase());
    setPage(0);
  };

  const rowsToDisplay = filterValue
    ? rows.filter((item) => (item.domainname || "").toLowerCase().includes(filterValue))
    : rows;

  return (
    <>
      <div className="main">
        <Toaster />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Block Domain" crumb="Players / Block Domain" />

              <div style={{ marginTop: "10px" }}>
                {/* <div className="table_search">
                  <TextField
                    style={{ marginBottom: "10px", width: "25%" }}
                    placeholder="Search domain..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div> */}
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                        aria-label="block domain table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">S.No</TableCell>
                            <TableCell align="center">Domain Name</TableCell>
                            <TableCell align="center">Reason</TableCell>
                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => (
                              <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                <TableCell align="center">{page * rowsPerPage + index + 1}</TableCell>
                                <TableCell align="center">{row?.domainName}</TableCell>
                                <TableCell align="center">{row?.reason || "-"}</TableCell>
                                <TableCell align="center">
                                  <DeleteIcon style={{ cursor: "pointer" }} onClick={() => deleteDomain(row)} />
                                </TableCell>
                              </TableRow>
                            ))}
                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={4} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[10, 25, { label: "All", value: -1 }]}
                              colSpan={4}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{ inputProps: { "aria-label": "rows per page" }, native: true }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>

                  <Modal show={show} onHide={handleClose} style={{ marginTop: "10%" }}>
                    <Modal.Header closeButton>
                      <Modal.Title>Add Block Domain</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Group className="mb-3">
                        <Form.Label>Domain Name / Email</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter domain or email"
                          value={domainName}
                          onChange={(e) => setDomainName(e.target.value)}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Reason</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter reason for blocking"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                        />
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={handleAdd}
                        style={{ background: "#04631e", borderColor: "#04631e" }}
                      >
                        Add
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => setShow(true)}
                >
                  Add Block Domain
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockDomain;
